import { TagsLayout } from '../../types';

export const DEFAULT_TAGS_LAYOUT: TagsLayout = {
    paddingX: '3',
    paddingY: '2',
    gap: '2',
    fontSize: 'b_sm',
    fontFamily: 'primary',
    iconSize: 20,
    lineHeight: 'b_sm',
    evenLineSkeletonWidth: '100%',
    oddLineSkeletonWidth: '70%',
};
